import "../AboutUs/AboutUs.css";
import "./terms_condition.css";
const TermsAndCondition = () => {
  return (
    <section className="">
      <img
        className="terms-of-use-bg"
        src="/assets/images/terms-of-use-bg.png"
        alt=""
      ></img>
      <div className="container mx-auto">
        <div className="mt-3">
          <div className="text-center">
            <div className=" style1">Terms of Use</div>
            <div className="mt-2 style2 mb-3">
              Connecting Diversity for a Decentralized Tomorrow.
            </div>
          </div>
          <div className="privacy-point-style mb-3">
            {/* ..................................About Us -1 ......................... */}

            <div>
              <ul>
                <p className="title-style">1. Acceptance of Terms</p>
                <p>
                  By using Zecurechain, you agree to be legally bound by these
                  Terms. If you do not agree to these Terms, please do not use
                  our service.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">
                  2. Registration and User Information
                </p>
                <p>
                  To use Zecurechain, you must register an account. You agree to
                  provide accurate, current, and complete information during the
                  registration process and to update such information to keep it
                  accurate, current, and complete. We may store and use your
                  registration information as described in our Privacy Policy.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">3. Payment and Subscription</p>
                <p>
                  Zecurechain offers both monthly and yearly subscription plans.
                  By subscribing to our service, you agree to pay the applicable
                  fees as described on our website. Payment will be processed
                  using the payment method you provide, and you authorize us to
                  charge the applicable fees.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">4. Use of Blockchain Technology</p>
                <p>
                  Zecurechain utilizes blockchain technology for the creation
                  and issuance of digital certificates and document storage.
                  While we strive to provide a secure and transparent service,
                  we do not guarantee the absolute security or immutability of
                  data on the blockchain. You acknowledge that blockchain
                  transactions are irreversible and that once data is recorded
                  on the blockchain, it cannot be altered or deleted.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">5. User Responsibilities</p>
                <p>You agree not to:</p>
                <p>Use Zecurechain for any unlawful or fraudulent purposes.</p>
                <p>
                  Attempt to gain unauthorized access to our system or interfere
                  with the proper functioning of Zecurechain.
                </p>
                <p>
                  Share your account credentials or provide access to your
                  account to others.
                </p>
                <p>
                  Use Zecurechain to store, transmit, or share any content that
                  violates the law or infringes on the rights of others.
                </p>
              </ul>
            </div>

            <div>
              <ul>
                <p className="title-style">6. Intellectual Property</p>
                <p>
                  All content and materials on Zecurechain, including but not
                  limited to software, logos, text, graphics, and images, are
                  protected by intellectual property laws and are the property
                  of Unitic. You may not use, reproduce, distribute, or modify
                  these materials without our prior written consent.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">7. Termination</p>
                <p>
                  We reserve the right to suspend or terminate your access to
                  Zecurechain, with or without notice, if you violate these
                  Terms or for any other reason we deem appropriate.
                </p>
              </ul>
            </div>

            <div>
              <ul>
                <p className="title-style">8. Changes to Terms</p>
                <p>
                  We may update these Terms from time to time, and any changes
                  will be effective upon posting. Your continued use of
                  Zecurechain after such changes will constitute your acceptance
                  of the updated Terms.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">9. Privacy</p>
                <p>
                  Your use of Zecurechain is also governed by our Privacy
                  Policy, which is incorporated by reference into these Terms.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">10. Contact Information</p>
                <p>
                  If you have any questions or concerns about these Terms or
                  Zecurechain, please contact us.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">11. Disclaimer of Warranties</p>
                <p>
                  Zecurechain is provided on an "as-is" and "as-available"
                  basis. We make no warranties or representations regarding the
                  accuracy, completeness, or reliability of the service. We
                  disclaim all warranties, whether express or implied, including
                  but not limited to the implied warranties of merchantability,
                  fitness for a particular purpose, and non-infringement.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">12. Limitation of Liability</p>
                <p>
                  In no event shall Unitic, its officers, directors, employees,
                  or agents be liable for any indirect, consequential, special,
                  incidental, or punitive damages, including but not limited to
                  loss of profits, data, or use, arising out of or in connection
                  with your use of Zecurechain, even if we have been advised of
                  the possibility of such damages. Our total liability to you
                  for any claim arising out of or relating to these Terms or
                  your use of Zecurechain shall be limited to the amount paid by
                  you for the service during the preceding twelve (12) months.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">13. Indemnification</p>
                <p>
                  You agree to indemnify and hold Unitic, its affiliates,
                  officers, directors, employees, and agents harmless from any
                  claims, damages, losses, liabilities, and expenses (including
                  attorneys' fees) arising out of or in connection with your use
                  of Zecurechain, your violation of these Terms, or your
                  violation of any third-party rights.
                </p>
              </ul>
            </div>
            <div>
              <ul>
                <p className="title-style">14. Entire Agreement</p>
                <p>
                  These Terms constitute the entire agreement between you and
                  Unitic regarding your use of Zecurechain and supersede all
                  prior or contemporaneous understandings and agreements,
                  whether oral or written.
                </p>
                <p className="title-style">15. Cancellation and Refund Policy</p>
                <p>
                We strive to provide the best service possible. If you are not entirely satisfied with your purchase, we're here to help.

<p>Cancellation:</p>
You can cancel your subscription at any time. To do so, please log in to your account and follow the cancellation instructions provided. Your access will be revoked at the end of the current billing cycle.

<p>Refund Policy:</p>
We offer a 5 day money-back guarantee. If you are not satisfied with our service within the first 14 days of your subscription, please contact us at support@zecurechain.com for a full refund.

After the 14th-day period, no refunds will be issued.
                </p>
              </ul>
            </div>
           
          </div>
        </div>
      </div>
    </section>
  );
};
export default TermsAndCondition;
